import styles from './InfoNote.module.css'
import { useTranslation } from "react-i18next";

const InfoNoteText = ({
    className = "",
    onClick = () => {},
}) => {
    const { t } = useTranslation();

    return (
        <span
            className={`${styles.infoNote} ${className}`}
            onClick={onClick}
        >
            {t("Bilgi")}
        </span>
    )
}

export default InfoNoteText;